import { Document } from '../types';

export const sampleDocuments: Document[] = [
  {
    id: 'd1',
    dealId: 'deal-1',
    name: 'Financial Due Diligence Report',
    type: 'application/pdf',
    uploadDate: '2024-03-01',
    lastModified: '2024-03-01',
    size: 2500000,
    path: '/documents/financial/',
    permissions: ['view', 'download'],
    version: 1,
    status: 'approved'
  },
  {
    id: 'd2',
    dealId: 'deal-1',
    name: 'Tech Stack Analysis',
    type: 'application/pdf',
    uploadDate: '2024-03-05',
    lastModified: '2024-03-05',
    size: 1800000,
    path: '/documents/technical/',
    permissions: ['view', 'download'],
    version: 1,
    status: 'review'
  },
  {
    id: 'd3',
    dealId: 'deal-2',
    name: 'Manufacturing Facility Assessment',
    type: 'application/pdf',
    uploadDate: '2024-03-10',
    lastModified: '2024-03-10',
    size: 3200000,
    path: '/documents/operations/',
    permissions: ['view', 'download'],
    version: 1,
    status: 'review'
  }
];